// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/left-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/check.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topBar{
    padding: 22px 34px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background-color: #fff;
    box-shadow: 0px 1px 15px #0000000f;
    border-top: 1px solid #0000000f;
}
.topBar .theraphy-name .title{
    font-size: 16px;
    font-weight: 500;
    color: #1D2432;
    margin-bottom: 0;
}

.breadcrumb{
    margin-bottom: 0;
}
.breadcrumb-item.active{
    color: #ADADAD;
    font-size: 16px;
    font-weight: 400;
    text-decoration: none;
}
.breadcrumb-item a{
    font-size: 16px;
    color: #1D2432;
    font-weight: 400;
    text-decoration: none;
}
.breadcrumb-item+.breadcrumb-item::before{
    content: "";
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 20px;
    width: 20px;
    background-repeat: no-repeat;
    margin-top: 4px;
}
/*  card data */
.linkCard{
    text-decoration: none;
}
.doctor-card{
    border-radius: 14px;
    box-shadow: 0px 1px 15px #0000000f;
    background-color: #fff;
    
}
.doctor-card .doctor-card-content{
    display: flex;
    align-items: center;
    padding: 21px 24px;
}
.doctor-card .doctor-card-content .image-part{
    width: 135px;
    height: 135px;
    border-radius: 50%;
}
.doctor-card .doctor-card-content .text-part{
    margin-left: 18px;
}
.doctor-card .doctor-card-content .text-part h5{
    font-size: 14px;
    color: #1D2432;
    font-weight: 500;
    margin-bottom: 8px;
}
.doctor-card .doctor-card-content .text-part h6{
    color: #FF6036;
    font-weight: 400;
    font-size: 14px;
    margin-bottom: 10px;
}
.doctor-card .doctor-card-content .text-part p{
    font-weight: 400;
    color: #1D2432;
    margin-bottom: 2px;
    font-size: 14px;
}
.doctor-card .doctor-card-content .text-part p.gray{
    font-size: 18px;
    color: #ADADAD;
}
.doctor-card .doctor-card-content .text-part p.small{
    font-size: 14px;
    font-weight: 500;
}
.doctor-card .doctor-card-content .text-part img{
    margin-top: 6px;
    margin-right: 5px;
}
.doctor-card .bottom-bar{
    background-color: #FDF5F2;
    color: #FF6036;
    font-size: 16px;
    font-weight: 500;
    padding: 16px 0;
    border-bottom-left-radius: 14px;
    border-bottom-right-radius: 14px;
}
.doctor-card .bottom-bar p{
    margin-bottom: 0;
    text-align: center;
    font-size: 14px;
}

/* appointmentcard */
.owl-carousel{
    /* padding-left: -20px; */
}
.appointment-card, .assign-doctor-card{
    padding: 24px;
    background-color: #fff;
    border-radius: 14px;
    box-shadow: 0px 1px 15px #0000000f;
    margin: 12px;
    margin-left:3px;
}
.appointment-card .img-time-part{
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}
.appointment-card .img-time-part .time-part p{
    font-size: 12px;
    font-weight: 500;
    text-align: right;
    margin-bottom: 4px;
}
.appointment-card .img-time-part .time-part p.gray{
    color: #ADADAD;
}
.appointment-card .text-part .name{
    font-size: 12px;
    font-weight: 500;
}
.appointment-card .text-part{
    margin-top: 12px;
}
.appointment-card .text-part h6{
    font-size: 12px;
    color: #ADADAD;
    font-weight: 400;
}
.appointment-card .text-part .date{
    font-size: 12px;
    font-weight: 500;
    color: #FFFFFF;
    background-color: #12D372;
    border-radius: 7px;
    padding: 10px;
    margin-top: 23px;
    text-align: center;
}

/* assign doctor slider */
.assign-doctor-card{
    text-align: center;
    padding: 0;
    padding-top: 24px;
}
.assign-doctor-card .doctor-card-content .text-part h5{
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 0;
    margin-top: 10px;
    color: #1D2432;
}
.assign-doctor-card .doctor-card-content .text-part p{
    color: #FF6036;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 10px;
}
.assign-doctor-card .doctor-card-content .owl-carousel .owl-item .image-part img{
    width:auto !important;
}
.assign-slider .owl-item .image-part img{
    /* width: auto !important; */
}
.assign-slider.owl-carousel .owl-item img{
    margin: auto;
}
.assign-slider .rating-part {
    display: flex;
    justify-content: center;
    margin-bottom: 30px;
}
.assign-slider.owl-carousel .owl-item .rating-part img{
    width: auto !important;
    margin: 0;
    margin-right: 6px;
}
.doctorList{
    text-decoration: none;
}
.assign-slider .bottom-part{
    background-color: #FDF5F2;
    padding: 20px;
    border-bottom-left-radius: 14px;
    border-bottom-right-radius: 14px;
}
.assign-slider .bottom-part p{
    margin-bottom: 0;
    color: #FF6036;
    font-size: 14px;
    font-weight: 500;
}
.componentBtn{
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    border-radius: 8px;
    background-color: #FF6036;
    padding: 8px;
}
.componentBtn:hover{
    background-color: #ff6036cf !important;
    box-shadow: none;
    border-color: #FF6036;
}
.componentBtn.green-btn{
    background-color: #12D372;
    width: 50%;
}
.componentBtn.componentBtn.green-btn{
    background-color: #12D372 !important;
    box-shadow: none;
    border-color: #12D372;
    font-size: 14px;
    width: 50%;
}
.white-shdow-btn{
    box-shadow: 0px 1px 15px #0000000f;
    width: 100%;
    padding: 20px;
    font-size: 14px;
    font-weight: 500;
    color: #FF6036;
    background-color: transparent;
    border-radius: 14px;
    margin-bottom: 15px;
    border: none;
}
.white-shdow-btn:hover{
    background-color: transparent;
    color: #FF6036;
}
/* upcomingPatientsCard */
.upcomingPatientsCard  .bottom-bar {
    background-color: #F5F2F2;
    color: #1D2432;
}
.upcomingPatientsCard .progressBar{
    padding: 0 24px 24px;
}

/* report card */
.report-card{
    display: flex;
    align-items: flex-start;
    padding: 12px;
    border-radius: 14px;
    box-shadow: 0px 1px 15px #0000000f;
    margin-top: 12px;
}
.report-card .image-block{
    height: 44px;
    width: 44px;
    background-color: #FDF5F2;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.report-card  .fileName{
    font-size: 14px;
    font-weight: 500;
}
.report-card  .fileNo{
    font-size:12px;
    color:#ADADAD;
}
.doctorDetailsCard .nextLink{
    display: block;
    height: 44px;
    width: 44px;
    border: 1px solid #E3E3E3;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.doctorDetailsCard{
    position: relative;
    z-index: 2;
}
.doctorDetailsCard.back-orange::before{
    background-color: #FDF5F2;
    position: absolute;
    content: "";
    height: 200px;
    width: 100%;
    top: 0;
    z-index: -1;
}
.doctorDetailsCard .edit-button{
    height: 60px;
    width: 60px;
    box-shadow: 0px 1px 15px #0000000f;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 15px;
    top: 15px;
    cursor: pointer;
    background-color: #fff;
}

/* exercise tab part */
.exercise-tab-part .nav-tabs{
    margin-top: 25px;
}
.exercise-tab-part .nav-tabs,.exercise-tab-part .nav-tabs .nav-link{
    border: 0;
}
.exercise-tab-part .nav-tabs .nav-item.show .nav-link, .exercise-tab-part .nav-tabs .nav-link.active{
    border: 0;
}
.exercise-tab-part .nav-tabs .nav-link:hover, .exercise-tab-part .nav-tabs .nav-link:focus, .exercise-tab-part .nav-tabs .nav-link.active{
    border: 0;
    background-color: #FF6036 !important;
    color: #fff !important;
}
.exercise-tab-part .nav-tabs .nav-link{
    border-radius: 26px;
    background-color: #FDF5F2;
    font-size: 14px;
    font-weight: 500;
    color: #FF6036;
    min-width: 90px;
    margin-right: 10px;
}
.exercise-card{
    box-shadow: 0px 1px 15px #0000000f;
    padding: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 14px;
}
.exercise-card .img-text-part{
    display: flex;
    align-items: center;
}
.exercise-card .text-part h6{
    font-size: 14px;
    font-weight: 500;
}
.exercise-card .text-part p{
    font-size: 14px;
    font-weight: 400;
    color: #ADADAD;
}
.tab-content{
    margin-top: 25px;
}

/* patientInfoData */
.patientInfoData{
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
}
.patientInfoData h6{
    border-bottom: 1px solid #EAEAEA;
    padding-bottom: 20px;
    width: 100%;
    margin-bottom: 20px;
}
/* .appointmentPart{
    height: 50vh;
    overflow: auto;
} */
/* ex-card */
.ex-card{
    box-shadow: 0px 1px 15px #0000000f;
    padding: 25px;
    text-align: center;
    border-radius: 14px;
}
.ex-card h6{
    font-size: 15px;
    font-weight: 500;
    margin-top: 14px;
    color: #1D2432;
}
/* link-card */
.common-link-card-part .link-card{
    box-shadow: 0px 1px 15px #0000000f;
    padding: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 14px;
    margin-bottom: 15px;
}
.common-link-card-part .link-card:last-child{
    margin-bottom: 0;
}
.common-link-card-part .link-card .text{
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 500;
    color: #1D2432;
}
.common-link-card-part .link-card .iconPart .iconRound{
    height: 35px;
    width: 35px;
    background-color: #FDF5F2;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
}
.common-link-card-part .link-card .iconPart {
    display: flex;
    align-items: center;
}
.common-link-card-part{
    max-width: 70%;
    margin: auto;
}
.common-link-card-part .img-block img{
    opacity: 0.6;
}
/* doctorName */
.doctorName{
    text-align: center;
    margin-bottom: 3rem;
}
.doctorName p{
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 0px;
}
.doctorName p.email{
    font-size: 14px;
    color: #ADADAD;
}


/* checkbox */

.control {
    display: block;
    position: relative;
    padding-left: 30px;
    margin-bottom: 15px;
    cursor: pointer;
    font-size: 18px;
  }
  .control input {
    position: absolute;
    z-index: -1;
    opacity: 0;
  }
  .control__indicator {
    position: absolute;
    top: 2px;
    left: 0;
    height: 26px;
    width: 26px;
    background: #e6e6e6;
    border-radius: 50%;
  }
  .control:hover input ~ .control__indicator,
  .control input:focus ~ .control__indicator {
    background: #ccc;
  }
  .control input:checked ~ .control__indicator {
    background: #FF6036;
  }
  .control:hover input:not([disabled]):checked ~ .control__indicator,
  .control input:checked:focus ~ .control__indicator {
    background: #FF6036;
  }
  .control input:disabled ~ .control__indicator {
    background: #e6e6e6;
    opacity: 0.6;
    pointer-events: none;
  }
  .control__indicator:after {
    content: '';
    position: absolute;
    display: none;
  }
  .control input:checked ~ .control__indicator:after {
    display: block;
  }
  .control--checkbox .control__indicator:after {
    left: 6px;
    top: 8px;
    height: 10px;
    width: 14px;
    background-repeat: no-repeat;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  .control--checkbox input:disabled ~ .control__indicator:after {
    border-color: #7b7b7b;
  }
  .filterList{
    list-style-type: none;
    padding: 0;
  }
  .filterList li{
    display: flex;
    justify-content: space-between;
    
    padding: 15px 0;
    border-bottom: 1px solid #EAEAEA;
  }
  .filterList li.selcted img{
    display: block;
  }
  .filterList li img{
    display: none;
  }
  .filterList li a{
    text-decoration: none;
    font-size: 14px;
    color: #1D2432;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }

  /* checkbox added */
  .checkbox{
    height: 26px;
    width: 26px;
  }
.checkbox input[type="checkbox"] {
    opacity: 0;
    display: none;
}

.checkbox label {
    position: relative;
    display: inline-block;
    
    /*16px width of fake checkbox + 6px distance between fake checkbox and text*/
    padding-left: 22px;
}

.checkbox label::before,
.checkbox label::after {
    position: absolute;
    content: "";
    
    /*Needed for the line-height to take effect*/
    display: inline-block;
}

/*Outer box of the fake checkbox*/
.checkbox label::before {
    height: 26px;
    width: 26px;
    border-radius: 50%;
    border: 1px solid #ADADAD;
    left: 3px;
    top: -15px;
}

/*Checkmark of the fake checkbox*/
.checkbox label::after {
    height: 7px;
    width: 14px;
    border-left: 2px solid;
    border-bottom: 2px solid;
    transform: rotate(-45deg);
    left: 9px;
    top: -7px;
    color: #fff;
}

/*Hide the checkmark by default*/
.checkbox input[type="checkbox"] + label::after {
    content: none;
}

/*Unhide on the checked state*/
.checkbox input[type="checkbox"]:checked + label::after {
    content: "";
}
.checkbox input[type="checkbox"]:checked + label::before{
    background-color: #FF6036;
    border-color: #FF6036;
}

.patientListpartTitle{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 14px;
}
.patientListpartTitle h6{
    font-size: 16px;
    font-weight: 500;
}
.patientListpartTitle a{
    font-size: 12px;
    color: #FF6036;
}


.owl-carousel .owl-item img{
    width: 105px !important;
}
.owl-carousel .owl-item .appPatient{
    /* width: 120px !important; */
}

.owl-item{
    width: 280px !important;
}

.star {
    color: #b3aaa9;
  }
  /* Filled star color */
  .star.filled {
    color: #ffcb49;
  }
      

  .fromAdd{
    border:#ff6036 2px solid;
  }

  .disabled-slot {
    color: #ccc;
    pointer-events: none;
}
.btn-close {
    position: absolute;
    right: 25px;
    top: 25px;
}`, "",{"version":3,"sources":["webpack://./src/assets/css/commonComponent.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;IACX,sBAAsB;IACtB,kCAAkC;IAClC,+BAA+B;AACnC;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,WAAW;IACX,yDAAiD;IACjD,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,eAAe;AACnB;AACA,eAAe;AACf;IACI,qBAAqB;AACzB;AACA;IACI,mBAAmB;IACnB,kCAAkC;IAClC,sBAAsB;;AAE1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,+BAA+B;IAC/B,gCAAgC;AACpC;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,oBAAoB;AACpB;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kCAAkC;IAClC,YAAY;IACZ,eAAe;AACnB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,4BAA4B;AAChC;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,+BAA+B;IAC/B,gCAAgC;AACpC;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,sCAAsC;IACtC,gBAAgB;IAChB,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,UAAU;AACd;AACA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,UAAU;AACd;AACA;IACI,kCAAkC;IAClC,WAAW;IACX,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,6BAA6B;IAC7B,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,6BAA6B;IAC7B,cAAc;AAClB;AACA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,oBAAoB;AACxB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,aAAa;AACjB;AACA;IACI,cAAc;IACd,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,WAAW;IACX,MAAM;IACN,WAAW;AACf;AACA;IACI,YAAY;IACZ,WAAW;IACX,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;IACf,sBAAsB;AAC1B;;AAEA,sBAAsB;AACtB;IACI,gBAAgB;AACpB;AACA;IACI,SAAS;AACb;AACA;IACI,SAAS;AACb;AACA;IACI,SAAS;IACT,oCAAoC;IACpC,sBAAsB;AAC1B;AACA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,kCAAkC;IAClC,aAAa;IACb,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,aAAa;IACb,2BAA2B;IAC3B,sBAAsB;AAC1B;AACA;IACI,gCAAgC;IAChC,oBAAoB;IACpB,WAAW;IACX,mBAAmB;AACvB;AACA;;;GAGG;AACH,YAAY;AACZ;IACI,kCAAkC;IAClC,aAAa;IACb,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;AACA,cAAc;AACd;IACI,kCAAkC;IAClC,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA,eAAe;AACf;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,cAAc;AAClB;;;AAGA,aAAa;;AAEb;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,UAAU;EACZ;EACA;IACE,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,kBAAkB;EACpB;EACA;;IAEE,gBAAgB;EAClB;EACA;IACE,mBAAmB;EACrB;EACA;;IAEE,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;EACtB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,SAAS;IACT,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,4BAA4B;IAC5B,yDAA4C;EAC9C;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,aAAa;IACb,8BAA8B;;IAE9B,eAAe;IACf,gCAAgC;EAClC;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA,mBAAmB;EACnB;IACE,YAAY;IACZ,WAAW;EACb;AACF;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;;IAErB,4EAA4E;IAC5E,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;;IAEX,4CAA4C;IAC5C,qBAAqB;AACzB;;AAEA,iCAAiC;AACjC;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;IACT,UAAU;AACd;;AAEA,iCAAiC;AACjC;IACI,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,wBAAwB;IACxB,yBAAyB;IACzB,SAAS;IACT,SAAS;IACT,WAAW;AACf;;AAEA,gCAAgC;AAChC;IACI,aAAa;AACjB;;AAEA,8BAA8B;AAC9B;IACI,WAAW;AACf;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,cAAc;AAClB;;;AAGA;IACI,uBAAuB;AAC3B;AACA;IACI,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,cAAc;EAChB;EACA,sBAAsB;EACtB;IACE,cAAc;EAChB;;;EAGA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;IACX,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb","sourcesContent":[".topBar{\r\n    padding: 22px 34px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n    background-color: #fff;\r\n    box-shadow: 0px 1px 15px #0000000f;\r\n    border-top: 1px solid #0000000f;\r\n}\r\n.topBar .theraphy-name .title{\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    color: #1D2432;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.breadcrumb{\r\n    margin-bottom: 0;\r\n}\r\n.breadcrumb-item.active{\r\n    color: #ADADAD;\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    text-decoration: none;\r\n}\r\n.breadcrumb-item a{\r\n    font-size: 16px;\r\n    color: #1D2432;\r\n    font-weight: 400;\r\n    text-decoration: none;\r\n}\r\n.breadcrumb-item+.breadcrumb-item::before{\r\n    content: \"\";\r\n    background-image: url('../images/left-arrow.svg');\r\n    height: 20px;\r\n    width: 20px;\r\n    background-repeat: no-repeat;\r\n    margin-top: 4px;\r\n}\r\n/*  card data */\r\n.linkCard{\r\n    text-decoration: none;\r\n}\r\n.doctor-card{\r\n    border-radius: 14px;\r\n    box-shadow: 0px 1px 15px #0000000f;\r\n    background-color: #fff;\r\n    \r\n}\r\n.doctor-card .doctor-card-content{\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 21px 24px;\r\n}\r\n.doctor-card .doctor-card-content .image-part{\r\n    width: 135px;\r\n    height: 135px;\r\n    border-radius: 50%;\r\n}\r\n.doctor-card .doctor-card-content .text-part{\r\n    margin-left: 18px;\r\n}\r\n.doctor-card .doctor-card-content .text-part h5{\r\n    font-size: 14px;\r\n    color: #1D2432;\r\n    font-weight: 500;\r\n    margin-bottom: 8px;\r\n}\r\n.doctor-card .doctor-card-content .text-part h6{\r\n    color: #FF6036;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    margin-bottom: 10px;\r\n}\r\n.doctor-card .doctor-card-content .text-part p{\r\n    font-weight: 400;\r\n    color: #1D2432;\r\n    margin-bottom: 2px;\r\n    font-size: 14px;\r\n}\r\n.doctor-card .doctor-card-content .text-part p.gray{\r\n    font-size: 18px;\r\n    color: #ADADAD;\r\n}\r\n.doctor-card .doctor-card-content .text-part p.small{\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n}\r\n.doctor-card .doctor-card-content .text-part img{\r\n    margin-top: 6px;\r\n    margin-right: 5px;\r\n}\r\n.doctor-card .bottom-bar{\r\n    background-color: #FDF5F2;\r\n    color: #FF6036;\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    padding: 16px 0;\r\n    border-bottom-left-radius: 14px;\r\n    border-bottom-right-radius: 14px;\r\n}\r\n.doctor-card .bottom-bar p{\r\n    margin-bottom: 0;\r\n    text-align: center;\r\n    font-size: 14px;\r\n}\r\n\r\n/* appointmentcard */\r\n.owl-carousel{\r\n    /* padding-left: -20px; */\r\n}\r\n.appointment-card, .assign-doctor-card{\r\n    padding: 24px;\r\n    background-color: #fff;\r\n    border-radius: 14px;\r\n    box-shadow: 0px 1px 15px #0000000f;\r\n    margin: 12px;\r\n    margin-left:3px;\r\n}\r\n.appointment-card .img-time-part{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: flex-start;\r\n}\r\n.appointment-card .img-time-part .time-part p{\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    text-align: right;\r\n    margin-bottom: 4px;\r\n}\r\n.appointment-card .img-time-part .time-part p.gray{\r\n    color: #ADADAD;\r\n}\r\n.appointment-card .text-part .name{\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n}\r\n.appointment-card .text-part{\r\n    margin-top: 12px;\r\n}\r\n.appointment-card .text-part h6{\r\n    font-size: 12px;\r\n    color: #ADADAD;\r\n    font-weight: 400;\r\n}\r\n.appointment-card .text-part .date{\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    color: #FFFFFF;\r\n    background-color: #12D372;\r\n    border-radius: 7px;\r\n    padding: 10px;\r\n    margin-top: 23px;\r\n    text-align: center;\r\n}\r\n\r\n/* assign doctor slider */\r\n.assign-doctor-card{\r\n    text-align: center;\r\n    padding: 0;\r\n    padding-top: 24px;\r\n}\r\n.assign-doctor-card .doctor-card-content .text-part h5{\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    margin-bottom: 0;\r\n    margin-top: 10px;\r\n    color: #1D2432;\r\n}\r\n.assign-doctor-card .doctor-card-content .text-part p{\r\n    color: #FF6036;\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    margin-bottom: 10px;\r\n}\r\n.assign-doctor-card .doctor-card-content .owl-carousel .owl-item .image-part img{\r\n    width:auto !important;\r\n}\r\n.assign-slider .owl-item .image-part img{\r\n    /* width: auto !important; */\r\n}\r\n.assign-slider.owl-carousel .owl-item img{\r\n    margin: auto;\r\n}\r\n.assign-slider .rating-part {\r\n    display: flex;\r\n    justify-content: center;\r\n    margin-bottom: 30px;\r\n}\r\n.assign-slider.owl-carousel .owl-item .rating-part img{\r\n    width: auto !important;\r\n    margin: 0;\r\n    margin-right: 6px;\r\n}\r\n.doctorList{\r\n    text-decoration: none;\r\n}\r\n.assign-slider .bottom-part{\r\n    background-color: #FDF5F2;\r\n    padding: 20px;\r\n    border-bottom-left-radius: 14px;\r\n    border-bottom-right-radius: 14px;\r\n}\r\n.assign-slider .bottom-part p{\r\n    margin-bottom: 0;\r\n    color: #FF6036;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n}\r\n.componentBtn{\r\n    font-size: 14px;\r\n    color: #fff;\r\n    font-weight: 400;\r\n    border-radius: 8px;\r\n    background-color: #FF6036;\r\n    padding: 8px;\r\n}\r\n.componentBtn:hover{\r\n    background-color: #ff6036cf !important;\r\n    box-shadow: none;\r\n    border-color: #FF6036;\r\n}\r\n.componentBtn.green-btn{\r\n    background-color: #12D372;\r\n    width: 50%;\r\n}\r\n.componentBtn.componentBtn.green-btn{\r\n    background-color: #12D372 !important;\r\n    box-shadow: none;\r\n    border-color: #12D372;\r\n    font-size: 14px;\r\n    width: 50%;\r\n}\r\n.white-shdow-btn{\r\n    box-shadow: 0px 1px 15px #0000000f;\r\n    width: 100%;\r\n    padding: 20px;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    color: #FF6036;\r\n    background-color: transparent;\r\n    border-radius: 14px;\r\n    margin-bottom: 15px;\r\n    border: none;\r\n}\r\n.white-shdow-btn:hover{\r\n    background-color: transparent;\r\n    color: #FF6036;\r\n}\r\n/* upcomingPatientsCard */\r\n.upcomingPatientsCard  .bottom-bar {\r\n    background-color: #F5F2F2;\r\n    color: #1D2432;\r\n}\r\n.upcomingPatientsCard .progressBar{\r\n    padding: 0 24px 24px;\r\n}\r\n\r\n/* report card */\r\n.report-card{\r\n    display: flex;\r\n    align-items: flex-start;\r\n    padding: 12px;\r\n    border-radius: 14px;\r\n    box-shadow: 0px 1px 15px #0000000f;\r\n    margin-top: 12px;\r\n}\r\n.report-card .image-block{\r\n    height: 44px;\r\n    width: 44px;\r\n    background-color: #FDF5F2;\r\n    border-radius: 10px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.report-card  .fileName{\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n}\r\n.report-card  .fileNo{\r\n    font-size:12px;\r\n    color:#ADADAD;\r\n}\r\n.doctorDetailsCard .nextLink{\r\n    display: block;\r\n    height: 44px;\r\n    width: 44px;\r\n    border: 1px solid #E3E3E3;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n.doctorDetailsCard{\r\n    position: relative;\r\n    z-index: 2;\r\n}\r\n.doctorDetailsCard.back-orange::before{\r\n    background-color: #FDF5F2;\r\n    position: absolute;\r\n    content: \"\";\r\n    height: 200px;\r\n    width: 100%;\r\n    top: 0;\r\n    z-index: -1;\r\n}\r\n.doctorDetailsCard .edit-button{\r\n    height: 60px;\r\n    width: 60px;\r\n    box-shadow: 0px 1px 15px #0000000f;\r\n    border-radius: 14px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: absolute;\r\n    right: 15px;\r\n    top: 15px;\r\n    cursor: pointer;\r\n    background-color: #fff;\r\n}\r\n\r\n/* exercise tab part */\r\n.exercise-tab-part .nav-tabs{\r\n    margin-top: 25px;\r\n}\r\n.exercise-tab-part .nav-tabs,.exercise-tab-part .nav-tabs .nav-link{\r\n    border: 0;\r\n}\r\n.exercise-tab-part .nav-tabs .nav-item.show .nav-link, .exercise-tab-part .nav-tabs .nav-link.active{\r\n    border: 0;\r\n}\r\n.exercise-tab-part .nav-tabs .nav-link:hover, .exercise-tab-part .nav-tabs .nav-link:focus, .exercise-tab-part .nav-tabs .nav-link.active{\r\n    border: 0;\r\n    background-color: #FF6036 !important;\r\n    color: #fff !important;\r\n}\r\n.exercise-tab-part .nav-tabs .nav-link{\r\n    border-radius: 26px;\r\n    background-color: #FDF5F2;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    color: #FF6036;\r\n    min-width: 90px;\r\n    margin-right: 10px;\r\n}\r\n.exercise-card{\r\n    box-shadow: 0px 1px 15px #0000000f;\r\n    padding: 14px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    border-radius: 14px;\r\n}\r\n.exercise-card .img-text-part{\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.exercise-card .text-part h6{\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n}\r\n.exercise-card .text-part p{\r\n    font-size: 14px;\r\n    font-weight: 400;\r\n    color: #ADADAD;\r\n}\r\n.tab-content{\r\n    margin-top: 25px;\r\n}\r\n\r\n/* patientInfoData */\r\n.patientInfoData{\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    flex-direction: column;\r\n}\r\n.patientInfoData h6{\r\n    border-bottom: 1px solid #EAEAEA;\r\n    padding-bottom: 20px;\r\n    width: 100%;\r\n    margin-bottom: 20px;\r\n}\r\n/* .appointmentPart{\r\n    height: 50vh;\r\n    overflow: auto;\r\n} */\r\n/* ex-card */\r\n.ex-card{\r\n    box-shadow: 0px 1px 15px #0000000f;\r\n    padding: 25px;\r\n    text-align: center;\r\n    border-radius: 14px;\r\n}\r\n.ex-card h6{\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n    margin-top: 14px;\r\n    color: #1D2432;\r\n}\r\n/* link-card */\r\n.common-link-card-part .link-card{\r\n    box-shadow: 0px 1px 15px #0000000f;\r\n    padding: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    border-radius: 14px;\r\n    margin-bottom: 15px;\r\n}\r\n.common-link-card-part .link-card:last-child{\r\n    margin-bottom: 0;\r\n}\r\n.common-link-card-part .link-card .text{\r\n    margin-bottom: 0;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    color: #1D2432;\r\n}\r\n.common-link-card-part .link-card .iconPart .iconRound{\r\n    height: 35px;\r\n    width: 35px;\r\n    background-color: #FDF5F2;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-right: 10px;\r\n}\r\n.common-link-card-part .link-card .iconPart {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n.common-link-card-part{\r\n    max-width: 70%;\r\n    margin: auto;\r\n}\r\n.common-link-card-part .img-block img{\r\n    opacity: 0.6;\r\n}\r\n/* doctorName */\r\n.doctorName{\r\n    text-align: center;\r\n    margin-bottom: 3rem;\r\n}\r\n.doctorName p{\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    margin-bottom: 0px;\r\n}\r\n.doctorName p.email{\r\n    font-size: 14px;\r\n    color: #ADADAD;\r\n}\r\n\r\n\r\n/* checkbox */\r\n\r\n.control {\r\n    display: block;\r\n    position: relative;\r\n    padding-left: 30px;\r\n    margin-bottom: 15px;\r\n    cursor: pointer;\r\n    font-size: 18px;\r\n  }\r\n  .control input {\r\n    position: absolute;\r\n    z-index: -1;\r\n    opacity: 0;\r\n  }\r\n  .control__indicator {\r\n    position: absolute;\r\n    top: 2px;\r\n    left: 0;\r\n    height: 26px;\r\n    width: 26px;\r\n    background: #e6e6e6;\r\n    border-radius: 50%;\r\n  }\r\n  .control:hover input ~ .control__indicator,\r\n  .control input:focus ~ .control__indicator {\r\n    background: #ccc;\r\n  }\r\n  .control input:checked ~ .control__indicator {\r\n    background: #FF6036;\r\n  }\r\n  .control:hover input:not([disabled]):checked ~ .control__indicator,\r\n  .control input:checked:focus ~ .control__indicator {\r\n    background: #FF6036;\r\n  }\r\n  .control input:disabled ~ .control__indicator {\r\n    background: #e6e6e6;\r\n    opacity: 0.6;\r\n    pointer-events: none;\r\n  }\r\n  .control__indicator:after {\r\n    content: '';\r\n    position: absolute;\r\n    display: none;\r\n  }\r\n  .control input:checked ~ .control__indicator:after {\r\n    display: block;\r\n  }\r\n  .control--checkbox .control__indicator:after {\r\n    left: 6px;\r\n    top: 8px;\r\n    height: 10px;\r\n    width: 14px;\r\n    background-repeat: no-repeat;\r\n    background-image: url('../images/check.svg');\r\n  }\r\n  .control--checkbox input:disabled ~ .control__indicator:after {\r\n    border-color: #7b7b7b;\r\n  }\r\n  .filterList{\r\n    list-style-type: none;\r\n    padding: 0;\r\n  }\r\n  .filterList li{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    \r\n    padding: 15px 0;\r\n    border-bottom: 1px solid #EAEAEA;\r\n  }\r\n  .filterList li.selcted img{\r\n    display: block;\r\n  }\r\n  .filterList li img{\r\n    display: none;\r\n  }\r\n  .filterList li a{\r\n    text-decoration: none;\r\n    font-size: 14px;\r\n    color: #1D2432;\r\n    display: flex;\r\n    width: 100%;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n  }\r\n\r\n  /* checkbox added */\r\n  .checkbox{\r\n    height: 26px;\r\n    width: 26px;\r\n  }\r\n.checkbox input[type=\"checkbox\"] {\r\n    opacity: 0;\r\n    display: none;\r\n}\r\n\r\n.checkbox label {\r\n    position: relative;\r\n    display: inline-block;\r\n    \r\n    /*16px width of fake checkbox + 6px distance between fake checkbox and text*/\r\n    padding-left: 22px;\r\n}\r\n\r\n.checkbox label::before,\r\n.checkbox label::after {\r\n    position: absolute;\r\n    content: \"\";\r\n    \r\n    /*Needed for the line-height to take effect*/\r\n    display: inline-block;\r\n}\r\n\r\n/*Outer box of the fake checkbox*/\r\n.checkbox label::before {\r\n    height: 26px;\r\n    width: 26px;\r\n    border-radius: 50%;\r\n    border: 1px solid #ADADAD;\r\n    left: 3px;\r\n    top: -15px;\r\n}\r\n\r\n/*Checkmark of the fake checkbox*/\r\n.checkbox label::after {\r\n    height: 7px;\r\n    width: 14px;\r\n    border-left: 2px solid;\r\n    border-bottom: 2px solid;\r\n    transform: rotate(-45deg);\r\n    left: 9px;\r\n    top: -7px;\r\n    color: #fff;\r\n}\r\n\r\n/*Hide the checkmark by default*/\r\n.checkbox input[type=\"checkbox\"] + label::after {\r\n    content: none;\r\n}\r\n\r\n/*Unhide on the checked state*/\r\n.checkbox input[type=\"checkbox\"]:checked + label::after {\r\n    content: \"\";\r\n}\r\n.checkbox input[type=\"checkbox\"]:checked + label::before{\r\n    background-color: #FF6036;\r\n    border-color: #FF6036;\r\n}\r\n\r\n.patientListpartTitle{\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    width: 100%;\r\n    margin-bottom: 14px;\r\n}\r\n.patientListpartTitle h6{\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n}\r\n.patientListpartTitle a{\r\n    font-size: 12px;\r\n    color: #FF6036;\r\n}\r\n\r\n\r\n.owl-carousel .owl-item img{\r\n    width: 105px !important;\r\n}\r\n.owl-carousel .owl-item .appPatient{\r\n    /* width: 120px !important; */\r\n}\r\n\r\n.owl-item{\r\n    width: 280px !important;\r\n}\r\n\r\n.star {\r\n    color: #b3aaa9;\r\n  }\r\n  /* Filled star color */\r\n  .star.filled {\r\n    color: #ffcb49;\r\n  }\r\n      \r\n\r\n  .fromAdd{\r\n    border:#ff6036 2px solid;\r\n  }\r\n\r\n  .disabled-slot {\r\n    color: #ccc;\r\n    pointer-events: none;\r\n}\r\n.btn-close {\r\n    position: absolute;\r\n    right: 25px;\r\n    top: 25px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
